import React from "react";
import Svg, { Path, G } from "react-native-svg";

export default function ClearSearchIcon(props) {
  const { onPress } = props;
  const color = "#2D3142";

  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      cursor="pointer"
      onPress={onPress}
    >
      <Path
        opacity="0.502883"
        d="M13.5385 7.26138C13.4134 7.13599 13.2436 7.06552 13.0665 7.06552C12.8894 7.06552 12.7196 7.13599 12.5945 7.26138L10.3998 9.45738L8.20518 7.26138C7.9445 7.0007 7.52186 7.0007 7.26118 7.26138C7.0005 7.52206 7.0005 7.9447 7.26118 8.20538L9.45718 10.4L7.26118 12.5947C7.0005 12.8554 7.0005 13.278 7.26118 13.5387C7.52186 13.7994 7.9445 13.7994 8.20518 13.5387L10.3998 11.3427L12.5945 13.5387C12.7631 13.7073 13.0089 13.7732 13.2393 13.7115C13.4696 13.6498 13.6496 13.4698 13.7113 13.2395C13.773 13.0091 13.7071 12.7633 13.5385 12.5947L11.3425 10.4L13.5385 8.20538C13.6639 8.08031 13.7344 7.91048 13.7344 7.73338C13.7344 7.55628 13.6639 7.38645 13.5385 7.26138Z"
        fill={color}
      />
      <Path
        opacity="0.502883"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3999 10.4C2.3999 5.98172 5.98162 2.39999 10.3999 2.39999C14.8164 2.4044 18.3955 5.98354 18.3999 10.4C18.3999 14.8183 14.8182 18.4 10.3999 18.4C5.98162 18.4 2.3999 14.8183 2.3999 10.4ZM3.73321 10.4C3.73321 14.0819 6.71797 17.0667 10.3999 17.0667C12.168 17.0667 13.8637 16.3643 15.1139 15.1141C16.3642 13.8638 17.0665 12.1681 17.0665 10.4C17.0665 6.71811 14.0818 3.73334 10.3999 3.73334C6.71797 3.73334 3.73321 6.71811 3.73321 10.4Z"
        fill={color}
      />
    </Svg>
  );
}
